import React from 'react'
import theme from 'src/lib/theme'
import { Text, Box, Flex } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import Avatar from 'src/components/Avatar/Avatar'
import { addIcon } from '../../assets'

type Props = {
  name: string
  login: string
  location: string
  avatarUrl: string
  onTextChange: (val: any) => void
  onFileChange: (val: any) => void
}

const UserForm: React.FC<Props> = ({
  name,
  login,
  location,
  avatarUrl,
  onTextChange,
  onFileChange,
}) => {
  const fileRef: any = React.createRef()

  return (
    <>
      <Box
        as="input"
        type="text"
        name="name"
        value={name}
        required
        placeholder={t('Your Name')}
        onChange={(e) => onTextChange(e)}
        style={{
          width: '100%',
          textAlign: 'center',
          fontSize: theme.fontSizes.xxl,
        }}
      />
      <Text as="p" fontSize="sm" mb="1x" css="font-family: monospace;">
        {login}
      </Text>
      <Box
        as="input"
        type="text"
        name="location"
        value={location}
        required
        placeholder={t('Your Location')}
        onChange={(e) => onTextChange(e)}
        style={{
          width: '100%',
          textAlign: 'center',
          fontSize: theme.fontSizes.sm,
          marginBottom: theme.space.sm,
        }}
      />
      <Avatar
        languageCode=""
        url={avatarUrl}
        size="xl"
        onClick={() => {
          fileRef.current.click()
        }}
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
          position="relative"
          borderRadius="full"
        >
          <Box
            src={addIcon}
            alt=""
            color="white100"
            borderRadius="full"
            cursor="pointer"
            as="img"
            zIndex={99}
          />
          <Box
            width="100%"
            height="100%"
            top={0}
            left={0}
            position="absolute"
            opacity={0.3}
            backgroundColor="black0"
            borderRadius="full"
            css={`
              &:hover {
                opacity: 0.5;
              }
            `}
          ></Box>
        </Flex>
      </Avatar>
      <Box
        as="input"
        type="file"
        id="file"
        ref={fileRef}
        onChange={(e) => onFileChange(e)}
        style={{ display: 'none' }}
      />
    </>
  )
}

export default UserForm
